import { GetStaticProps, GetStaticPaths, NextPage } from "next"
import { Component, loadStaticProps, PageProps } from "@/pages-shared/listing"

const Page: NextPage<PageProps> = (props) => (
  <Component basePath="components" title="Components" {...props} />
)

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: "blocking",
  }
}

export const getStaticProps: GetStaticProps = async (context) => {
  try {
    return {
      props: await loadStaticProps(context, "components"),
      revalidate: 24 * 60 * 60,
    }
  } catch (error: any) {
    if (error.status === 404) {
      return {
        notFound: true,
        revalidate: 24 * 60 * 60,
      }
    }
    throw error
  }
}

export default Page
